import V2FundingHistoryTable from 'src/components/HistoryTables/V2FundingHistoryTable';
import PortfolioHistoryFundingTableControls from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryFundingTable/PortfolioHistoryFundingTableControls';

export default function PortfolioHistoryFundingTable() {
	return (
		<div>
			<PortfolioHistoryFundingTableControls />
			<V2FundingHistoryTable />
		</div>
	);
}
